import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import MyAccount from "@/pages/MyAccount";
import SponsorshipSuccess from "@/pages/SponsorshipSuccess";
import SponsorshipCancel from "@/pages/SponsorshipCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminMessages from "@/pages/AdminMessages";
import PublicParticipants from "@/pages/PublicParticipants";
import Winners from "@/pages/Winners";
import CouponView from "@/pages/CouponView";
import CouponValidate from "@/pages/CouponValidate";
import LoginPage from "@/pages/LoginPage";
import CampInfo from "@/pages/CampInfo";
import AdminLogistics from "@/pages/AdminLogistics";
import CheckIn from "@/pages/CheckIn";
import CheckInQRSheet from "@/pages/CheckInQRSheet";
import LogisticsTV from "@/pages/LogisticsTV";
import RoleLogin from "@/pages/RoleLogin";
import CheckInScanner from "@/pages/CheckInScanner";
import RoomSheetsPage from "@/pages/RoomSheetsPage";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pago/exito" element={<PaymentSuccess />} />
          <Route path="/pago/cancelado" element={<PaymentCancel />} />
          <Route path="/mi-cuenta/:id" element={<MyAccount />} />
          <Route path="/patrocinio/exito" element={<SponsorshipSuccess />} />
          <Route path="/patrocinio/cancelado" element={<SponsorshipCancel />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/mensajes" element={<AdminMessages />} />
          <Route path="/inscritos" element={<PublicParticipants />} />
          <Route path="/ganadores" element={<Winners />} />
          <Route path="/cupon/:code" element={<CouponView />} />
          <Route path="/cupon/:code/validar" element={<CouponValidate />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/info" element={<CampInfo />} />
          <Route path="/admin/logistica" element={<AdminLogistics />} />
          <Route path="/admin/logistica/qr" element={<CheckInQRSheet />} />
          <Route path="/admin/logistica/hojas" element={<RoomSheetsPage />} />
          <Route path="/admin/logistica/tv" element={<LogisticsTV />} />
          <Route path="/kiosko" element={<RoleLogin role="kiosko" />} />
          <Route path="/kiosko/scan" element={<CheckInScanner />} />
          <Route path="/logistica" element={<RoleLogin role="logistica" />} />
          <Route path="/checkin/:id" element={<CheckIn />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
